<template>
	<div class="article-list--categories container pt-300 pb-300">
		<div class="display-flex align-items-stretch flex-wrap-wrap">
			<div
				v-for="(featuredCategory, featCatId) in featuredCategories"
				:key="featuredCategory.category._id || featCatId"
				class="flex-category col-12 col-4-md mb-400-smo mb-100-md"
				:class="{
					'pl-150-md pl-200-lg': featCatId !== 0,
					'pr-150-md pr-200-lg': featCatId !== 2
				}"
			>
				<div class="flex-helper-container col-12">
					<h2 class="heading-2 mb-50 mt-50-lg">{{ featuredCategory.category.name }}</h2>
					<p class="category-description mb-100">
						{{ featuredCategory.category.description }}
					</p>

					<ArticleCard
						v-for="blog in featuredCategory.articles.slice(0, 1)"
						:key="blog._id"
						:article="blog"
						:show-cover-image="true"
						:show-divider="true"
					/>

					<ArticleCard
						v-for="blog in featuredCategory.articles.slice(1)"
						:key="blog._id"
						:article="blog"
						:show-divider="true"
					/>
				</div>

				<span>
					<BaseLink
						classes="button button-outline mt-300"
						:link="{
							router: 'blog-category',
							params: { categoryUrlSlug: featuredCategory.category.slug.current }
						}"
					>
						See all {{ featuredCategory.category.name }}
					</BaseLink>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import ArticleCard from '@components/blog/article-card.vue';
import { SanityBlogCategoryWithArticles } from 'types/sanity/education-center';

interface Props {
	featuredCategories: Array<SanityBlogCategoryWithArticles>;
	classes?: string;
}

defineProps<Props>();
</script>

<style lang="scss">
@use '../../styles/constants/colors.scss' as *;
@use '../../styles/utilities/respond-to.scss' as *;

.article-list--categories {
	.flex-category {
		align-items: flex-start;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;

		@include respond-to(md) {
			border-right: 1px solid gray(20);
		}

		&:last-of-type {
			border-right: none;
		}

		> span {
			align-self: flex-end;
			width: 100%;

			.button {
				text-align: center;
				width: 100%;
			}
		}
	}

	.category-description {
		@include respond-to(md) {
			min-height: 50px;
		}
	}

	.article-list-item {
		margin: 0;
	}

	.article-cover-image {
		height: 225px;
		padding-bottom: 0;
	}
}
</style>
